export const AssetType = {
  Pictogram: 'pictogram',
  Illustration: 'illustration',
  Icon: 'icon',
  Lottie: 'lottie'
};
//# sourceMappingURL=constants.js.map